import { render, staticRenderFns } from "./SportelloBarView.vue?vue&type=template&id=22464f1c&"
import script from "./SportelloBarView.vue?vue&type=script&lang=ts&"
export * from "./SportelloBarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports